import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Cta from "../components/CtaMarketing";

import "../styles/common.css";
import "../styles/service.css";

import imgIssue01 from "../img/common/illustration_service_marketing.svg";
import imgfeature01 from "../img/marketing/img_feature_01.png";
import imgfeature02 from "../img/marketing/img_feature_02.png";
import imgfeature03 from "../img/marketing/img_feature_03.png";
import imgfeature04 from "../img/marketing/img_feature_04.png";


const Marketing = () => {

  return (
    <>
      <Navbar></Navbar>
      <main className='marketing'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>マーケティング支援</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/">Home</a></li>
                <li aria-current="page">マーケティング支援</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='issue'>
          <div className='flex marketing-issue'>
            <div className='marketing-issue__text'>
              <h2>LOGOTでは、Web集客・問い合わせ獲得を目的としたアウトソーシングサービスです。</h2>
              <p>Webサイトは、公開しただけでは十分な問い合わせを生み出すことはできません。<br />継続的な運用と適切なマーケティング施策を通じて、“育てる”ことが必要不可欠です。<br />しかし、Webサイトを安定的に成長させ、一定の水準まで引き上げるには専門的なWebマーケティングの知識が求められます。<br />LOGOTでは、問い合わせを増やし、集客力を強化するための戦略的な施策を提供し、Webサイトを成果の出る状態へと導きます。<br />安定的に問い合わせを獲得・Web集客の実現に向け、貴社サイトの運用を代行いたします。</p>
            </div>
            <div className='marketing-issue__img'>
            <img src={imgIssue01} alt="" />
            </div>
          </div>
          <div className='issue-text'>
          <p>まずは<br className='sp-only'/><span>「Web集客を軌道に乗せる」</span><br/>そのためにも、<br className='sp-only'/><span>サイト運用のアウトソーシング</span>がおすすめ。</p>
          </div>
        </section>
        <section className='feature'>
          <div className="title">
            <p className='title-lead'>FEATURE</p>
            <h2>マーケティング支援の4つの特長</h2>
          </div>
          <div className='feature-box flexBox-imgText'>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>01</span></p>
                <h3>目的を明確にしたLPの作成と運用</h3>
                <p className='feature-item__detail'>LOGOTは、成果を出すためのLP（ランディングページ）を作成し、運用をサポートします。ターゲットの行動を分析し、効果的なデザインやCTAを設計。A/Bテストを活用して改善を重ね、問い合わせにつながるページへと最適化します。<br />さらに、広告運用やSEO対策と連携し、自然な流入を増やすことで安定した成果を実現。戦略的なLP運用で、お客様のビジネス成長をサポートします。</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature01} alt="" />
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature02} alt="" />
              </div>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>02</span></p>
                <h3>企業のSNSを効果的に活用し、ブランドの認知度を高めます</h3>
                <p className='feature-item__detail'>LOGOTのSNS運用は、「企業のSNSを効果的に活用し、ブランドの認知度を高めるサービス」です。運用が軌道に乗った後は、お客様自身での運用も可能な設計を想定しています。<br />そのため、一時的な効果に頼るのではなく、長期的に成果が続く投稿戦略やインフルエンサーマーケティングを活用。データ分析を基に最適な投稿内容を提案し、ブランドのファンを増やしながら、安定したSNS運用を実現します。</p>
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>03</span></p>
                <h3>ユーザーに確実にアプローチを実現</h3>
                <p className='feature-item__detail'>LOGOTでは、Google広告やSNS広告（Facebook・Instagram・X・LinkedIn など）の運用代行を行い、最適な広告戦略でターゲットにリーチし、費用対効果の高い集客を実現します。<br />市場調査・競合分析の中でキーワードを策定し、広告に反映させます。</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature03} alt="" />
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature04} alt="" />
              </div>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>04</span></p>
                <h3>最新技術（DX・AI）を駆使した、作業代行も可能</h3>
                <p className='feature-item__detail'>LOGOTでは、最新技術（DX・AI）を活用した作業代行を提供し、業務効率化と成果向上を実現します。メール営業の自動化やターゲットリストの最適化、AIを活用したブログ投稿・コンテンツ制作まで幅広く対応。<br />DXを活用することで、人的コストを削減しながら、より精度の高いマーケティング施策を実行可能にします。データ分析を活かした戦略設計と運用で、企業の成長を支援します。</p>
              </div>
            </div>
          </div>
        </section>
        <Cta></Cta>
        <section className='flow'>
          <div className="title">
            <p className='title-lead'>FLOW</p>
            <h2>ブランディング支援の流れ</h2>
          </div>
          <ol className='flow-box'>
            <li>
              <div className='flow-box__number'><p>1</p></div>
              <div className='flow-box__text'>
                <h3>事前準備・ヒアリング</h3>
                <p>LOGOTでは、プロジェクト開始前に、企業が目指す6ヶ月後のブランドの理想像や、現在抱えている課題について詳しくヒアリングします。<br />WebサイトやSNSがすでに運用されている場合は、市場調査・競合分析・ユーザーインサイトのリサーチを実施し、ブランドが持つ強みを活かすための戦略を立案する準備を整えます。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>2</p></div>
              <div className='flow-box__text'>
                <h3>キックオフミーティング</h3>
                <p>事前に収集したデータをもとに、ターゲット市場のニーズや競合との差別化ポイントを深掘りし、ブランドの持つ「世界観」を定義します。<br />また、ローカライズ戦略・コンテンツ設計・ビジュアルアイデンティティ の方向性を決定し、6ヶ月間のロードマップを作成。<br/>戦略を具体化し、ブランド価値を最大限に高めるための最適なアプローチをご提案します。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>3</p></div>
              <div className='flow-box__text'>
                <h3>プラン実行</h3>
                <p>LOGOTでは、単に施策を実施するだけでなく、各施策の効果をデータで分析し、企業・ブランドの成長を最大化するための改善施策を提案します。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>4</p></div>
              <div className='flow-box__text'>
                <h3>効果測定とレポート作成</h3>
                <p>サイトアクセスの分析結果をまとめ、レポートを作成。毎月1回、情報を共有いたします。また前月までに実施した施策の効果検証・改善案を検討し、翌月のプランに反映いたします。サイトアクセスの分析結果をまとめ、レポートを作成。毎月1回、情報を共有いたします。また前月までに実施した施策の効果検証・改善案を検討し、翌月のプランに反映いたします。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>5</p></div>
              <div className='flow-box__text'>
                <h3>毎月のお打ち合わせ</h3>
                <p>前月までのマーケティング施策の実績をご報告。その内容を踏まえた翌月のプランもご提案・決定します。また、最終的な目標に対する進捗状況についても共有いたします。</p>
              </div>
            </li>
          </ol>
        </section>
        <section className='qa'>
          <div className="title">
            <p className='title-lead'>Q&A</p>
            <h2>よくある質問</h2>
          </div>
          <ul className='qa-box'>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>最低契約期間はありますか？</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>契約月から起算して、「6ヶ月間」の最低契約期間を設けています。</p></dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>他社が制作したサイトでも契約可能ですか？</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>はい、対応可能です。ただし、当社が構築に関わっていないサイトの場合、仕様や設計の詳細が不明なため、一部対応が困難な場合がございます。あらかじめご了承ください。</p></dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>マーケティング支援の具体的な内容を教えて</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>事前にお聞きしたお客様の課題をもとに、市場分析・アクセス分析を含む多角的な調査を行い、「今後のブランド運用方針」や「必要な施策・改修案」をご提案いたします。<br/>ご状況によって提案内容は様々ですが、アクセス数が課題であれば、「どの記事をリライトするか？」、問い合わせ数が課題があれば、「問い合わせを増やすための対策は？」など、戦略だけでなく、具体的な戦術までご提案し、今後の方針を決定いたします。</p></dd>
              </dl>
            </li>
          </ul>
        </section>
        <Cta></Cta>
      </main >
      <Footer></Footer>
    </>
  );
};

export default Marketing